
import data from './emojis-data.json';
export default {
    props:
    {
        show_arrow:
        {
            type: Boolean,
            required: false,
            default: false
        },

    },
    computed:
    {
        categories() {
            return Object.keys(data);
        },

        category_emojis: () => (category) => {
            return Object.values(data[category]);
        }
    },
    data() {
        return {
            open: false
        }
    },
    methods:
    {
        handleEmojiClick(e, emoji) {
            e.preventDefault();
            this.$emit('emoji_click', emoji);
            this.open = false
        }
    }
}
